import { render, staticRenderFns } from "./GeneralListFilter.vue?vue&type=template&id=2fa50ace"
import script from "./GeneralListFilter.vue?vue&type=script&lang=ts"
export * from "./GeneralListFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports